import { NavigateBackLink } from '@exam-management/components';
import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { QConfigDetailHeaderButtonGroup } from '../qconfig-detail-header-button-group';
import { QConfigNavigationTabs } from '../qconfig-navigation-tabs';

export default function QConfigDetailHeader() {
  const { qConfigData, courseId } = useQConfig();
  const { name, updatedAt, status, id, totalQuestions } = qConfigData;
  return (
    <PageHeader
      title={name}
      linkAdornment={
        <NavigateBackLink
          to='/exam-courses/:courseId/qconfigs'
          params={{ courseId }}
          label='Back to QConfig'
        />
      }
      subtitleSection={
        <Text variant='body2' sx={{ color: 'text.secondary', textAlign: 'right', width: 1 }}>
          {`Last Modified: ${formatDateTime(updatedAt)}`}
        </Text>
      }
      endAdornment={
        <QConfigDetailHeaderButtonGroup
          status={status}
          qConfigId={id}
          name={name}
          totalQuestions={totalQuestions}
        />
      }
      tabs={<QConfigNavigationTabs />}
    />
  );
}
